module.exports = "h2 {\r\n    text-align: center;\r\n}\r\n\r\nh3 {\r\n    text-align: center;\r\n}\r\n\r\n#pokerDiv {\r\n    display: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/stats/stats.component.css
// module id = ./src/app/stats/stats.component.css
// module chunks = main